/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useMemo } from "react";
import { useTopSpendingApplicationsQuery } from "~/generated/graphql";
import { useCurrency } from "~/hooks";
import { applyRate } from "~/tools";
import { formatTotalCosts, transformSpendingData } from "./helpers";

const APP_LIMIT = 6;

export function useTopSpendingApplications() {
  const { currency, baseCurrency } = useCurrency();
  const { data, loading, error } = useTopSpendingApplicationsQuery({
    variables: { limit: APP_LIMIT },
  });

  const memoizedData = useMemo(
    () => transformSpendingData(APP_LIMIT, data?.topSpendingApplications),
    [data]
  );

  const areCostsAvailable = memoizedData.totalCosts > 0;

  const topSpendingApplicationSum = formatTotalCosts(
    applyRate(memoizedData.totalCosts, currency, baseCurrency),
    currency
  );

  return {
    data: memoizedData,
    topSpendingApplicationSum,
    areCostsAvailable,
    loading,
    error,
  };
}
